import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './ReturnPolicy.module.scss';
const ReturnPolicy = () => {
    return (_jsx("main", { className: styles.returnPolicy, children: _jsxs("section", { className: styles.returnPolicyWrapper, children: [_jsx("h2", { children: "To initiate a return, please contact us." }), _jsx("p", { children: " Returns are subject to the manufacturer's return policy." })] }) }));
};
export default ReturnPolicy;
